import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueScrollTo from 'vue-scrollto';

Vue.config.productionTip = false;
Vue.config.devtools = false;
Vue.use(VueScrollTo);

Vue.prototype.filteredName = function (val) {
  val = val.replace(/[^А-Яа-яІіЇїҐґЄє,'‎\u2018\u2019‎ -]/g, '');
  return val;
};

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
